import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { MaskitoDirective } from '@maskito/angular';

import { MiscModule } from '../../misc/misc.module';
import { PersonalDetailsPageRoutingModule } from './personal-details-routing.module';
import { PersonalDetailsPageComponent } from './personal-details.page';

@NgModule({
  declarations: [PersonalDetailsPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PersonalDetailsPageRoutingModule,
    ReactiveFormsModule,
    MaskitoDirective,
    MiscModule
  ]
})
export class PersonalDetailsPageModule {}
